export const AppointByСomprehensiveProgram = {
  delimiters: ['#{', '}'],
  template: `
    <div class='grid comprehensive-program'>
      <span>Оплатить услуги счетом</span>
      <v-select placeholder='Выберите счет для добавления в него услуг'></v-select>
      <span >План лечения</span>
      <v-select placeholder='Выберите план лечения'></v-select>
    </div>
    `,
};
